import { render, staticRenderFns } from "./CreateFull.vue?vue&type=template&id=255abff2&scoped=true"
import script from "./CreateFull.vue?vue&type=script&lang=js"
export * from "./CreateFull.vue?vue&type=script&lang=js"
import style0 from "./CreateFull.vue?vue&type=style&index=0&id=255abff2&prod&lang=scss"
import style1 from "./CreateFull.vue?vue&type=style&index=1&id=255abff2&prod&scoped=true&lang=css"
import style2 from "./CreateFull.vue?vue&type=style&index=2&id=255abff2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255abff2",
  null
  
)

export default component.exports